import request from '@/services/interceptor.js'

export const searchCatalogo = (q) => {
    return request({
        url: '/catalogo/search',
        method: 'get',
        params: { q },
    })
}

export const getCatalogoById = (id) => {
    return request({
        url: `/catalogo/${id}`,
        method: 'get',
    })
}

export const createCatalogo = (data) => {
    return request({
        url: '/catalogo',
        method: 'post',
        data,
    })
}

export const updateCatalogo = (id, data) => {
    return request({
        url: `/catalogo/${id}`,
        method: 'put',
        data,
    })
}

export const getTagsCatalogo = () => {
    return request({
        url: '/catalogo/tags',
        method: 'get',
    })
}
